import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
import { keyframes } from '@mui/material/styles';
const favoriteButtonSize = '40px';
const favoriteButtonLargeSize = '60px';
const favoriteButtonLargePositioning = '12px';
const favoriteIconSizeLarge = '44px';
const floatUp = keyframes `
  0% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateY(-30px) scale(1);
  }
`;
const scalePulse = keyframes `
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`;
export const useStyles = makeStyles()((theme) => ({
    tooltipArrow: {
        fontSize: '1.2rem',
        '::before': {
            backgroundColor: 'rgba(0, 0, 0, 0.60)',
        },
    },
    tooltip: Object.assign(Object.assign({ backgroundColor: 'rgba(0, 0, 0, 0.60)' }, theme.typography.xxs_bold), { padding: spacing.xs, borderRadius: 0 }),
    customTooltipPopper: {
        zIndex: 'auto',
        '&[data-popper-placement*="left"]': {
            // Using !important to override MUI Popper's inline styles
            marginRight: `${spacing.xxs} !important`,
        },
    },
    customTooltipPopperFavorited: {
        '&[data-popper-placement*="bottom"]': {
            // Using !important to override MUI Popper's inline styles for favorited tooltip
            marginTop: `${spacing.xxs} !important`,
        },
    },
    toolTipContent: {
        display: 'flex',
    },
    closeIcon: {
        cursor: 'pointer',
        marginLeft: '12px',
        width: spacing.small,
        height: spacing.small,
    },
    favoriteButtonContainer: {
        width: spacing.xl,
        height: spacing.xl,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        top: spacing.xxs,
        right: spacing.xxs,
        position: 'absolute',
        zIndex: 1,
        cursor: 'pointer',
    },
    favoriteButtonContainerLarge: {
        width: favoriteButtonLargeSize,
        height: favoriteButtonLargeSize,
        [theme.breakpoints.up('md')]: {
            top: favoriteButtonLargePositioning,
            right: favoriteButtonLargePositioning,
        },
    },
    favoriteButton: {
        width: favoriteButtonSize,
        height: favoriteButtonSize,
        position: 'absolute',
        backgroundColor: '#FFFFFFB3',
        zIndex: 1,
        padding: spacing.xs,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        '& svg': {
            display: 'block',
            flexShrink: 0,
        },
        '& span': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 0,
        },
        '&:hover': {
            backgroundColor: '#FFFFFFB3',
        },
    },
    favoriteButtonLarge: {
        width: favoriteButtonLargeSize,
        height: favoriteButtonLargeSize,
    },
    favoriteIcon: {
        color: colors.primary.gold4,
        width: spacing.medium,
        height: spacing.medium,
    },
    favoriteIconExpand: {
        transition: 'color 0.3s',
        animation: `${scalePulse} 1s ease-in-out`,
    },
    favoriteIconLarge: {
        width: favoriteIconSizeLarge,
        height: favoriteIconSizeLarge,
    },
    floatingHeart: {
        zIndex: 1,
        position: 'absolute',
        right: spacing.small,
        pointerEvents: 'none',
        color: colors.primary.gold4,
        animation: `${floatUp} 1s ease-out forwards`,
    },
    fromProductCardMobile: {
        [theme.breakpoints.down('md')]: {
            right: '12px',
        },
    },
    // ── Redesign (isPDPRedesign) styles ───────────────────────────────────────
    // Used when the FavoriteButton sits in the CTA row next to the Buy Now
    // button. Removes absolute positioning and renders a bordered square button
    // that stretches to the same height as the primary CTA.
    favoriteButtonContainerRedesign: {
        // Remove the absolute overlay behaviour — render inline in flex flow
        position: 'relative',
        top: 'unset',
        right: 'unset',
        zIndex: 'auto',
        // Fill the height of the CTA row (ctaFavoriteButtonWrapper uses stretch)
        width: '40px',
        // height: '100%',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'border-color 0.2s, background-color 0.2s, box-shadow 0.2s',
        '&:focus-within': {
            outline: 'none',
        },
    },
    favoriteButtonRedesign: {
        // IconButton inside the redesign container — fills the container
        position: 'relative',
        width: '40px',
        height: '40px',
        minWidth: '40px',
        minHeight: '40px',
        backgroundColor: '#fff',
        borderRadius: '50%',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        '& svg': {
            display: 'block',
            flexShrink: 0,
        },
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    favoriteIconRedesign: {
        width: spacing.medium,
        height: spacing.medium,
        color: colors.supplementary.black,
    },
    favoriteIconRedesignActive: {
        // Filled state — use the brand gold to signal "saved"
        color: colors.primary.gold4,
    },
    // ProductCard new design uses a larger heart than the PDP redesign default — scoped so it never affects PDP sizing.
    favoriteIconRedesignNewCategory: {
        width: spacing.large,
        height: spacing.large,
    },
}));
